import { useState ,useEffect} from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Check, Crown, Calendar, Link2, ArrowLeft, Copy, LinkIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { getSubscriptionPlanDetails,getVendorDirectBookingLinkVenuesSubscription } from "@/store/thunkMidddleware/paymentMiddleware";
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { Values } from "@/constants/Values";
import { getCompletedVenueDetails } from '@/store/thunkMidddleware/turfMiddleware';
import SubscriptionPageSkeleton from '@/components/skeletons/SubscriptionPageSkeleton'
import moment from "moment";
import { ButtonWithLoader } from "@/components/ui/buttonwithloader";
import CommonPopup from "@/components/popups/commonPopup";
import DirectBookingPremium from "./DirectBookingLink";
import {setShowPaymentSuccess} from "@/store/slices/global.Slice";
import PaymentProcessing from "@/pages/Payment/paymentProcessing";
import SuccessBookingAnimation from "@/pages/Payment/SuccessBookingAnimation"
import { getVendorProfile } from '@/store/thunkMidddleware/usersMiddleware';
import routes from "@/routes/routes.json"

interface Venue {
  id: string;
  name: string;
  location: string;
  image: string;
  subscription: {
    isActive: boolean;
    plan?: string;
    expiresAt?: string;
    directBookingLink?: string;
  };
}

const mockVenues: Venue[] = [
  {
    id: "1",
    name: "Green Field Arena",
    location: "Downtown Sports Complex",
    image: "https://images.unsplash.com/photo-1529900748604-07564a03e7a6?w=400",
    subscription: {
      isActive: true,
      plan: "Premium",
      expiresAt: "2025-03-15",
      directBookingLink: "https://bookyourzone.com/green-field-arena",
    },
  },
  {
    id: "2",
    name: "Blue Court Stadium",
    location: "City Center",
    image: "https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=400",
    subscription: {
      isActive: true,
      plan: "Basic",
      expiresAt: "2025-02-28",
      directBookingLink: "https://bookyourzone.com/blue-court",
    },
  },
  {
    id: "3",
    name: "Purple Sports Hub",
    location: "West End",
    image: "https://images.unsplash.com/photo-1551958219-acbc608c6377?w=400",
    subscription: {
      isActive: false,
    },
  },
  {
    id: "4",
    name: "Elite Cricket Ground",
    location: "North District",
    image: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=400",
    subscription: {
      isActive: false,
    },
  },
];

const Subscription = () => {
  const navigate = useNavigate();
  const [venues] = useState<Venue[]>(mockVenues);
  const dispatch = useAppDispatch()
  const profileState = useAppSelector(state => state.profile)
  const authState = useAppSelector(state => state.auth)

  const { showPaymentProcessing,showPaymentSuccess} = useAppSelector((state) => state.globalstate);
  const { getVendorDirectBookingLinkVenuesSubscriptionResponse ,getSubscriptionPlanDetailsResponse} = useAppSelector((state) => state.payment);
  const [showSubscriptionModal,setShowSubscriptionModal] = useState(false)
  const activeVenues = venues.filter((v) => v.subscription.isActive);
  const inactiveVenues = venues.filter((v) => !v.subscription.isActive);
  const [copied, setCopied] = useState(false);
  const [inactiveVenuesSubscripiton,setInactiveVenuesSubscripiton] = useState([])
    const [selectedVenueId,setSelectedVenueId]= useState(null)
    const [selectedVenueIdForCopy,setSelectedVenueIdForCopy]= useState(null)

    const [selectedVenueDetailsForSubscription,setSelectedVenueDetailsForSubscription]= useState(null)


  // const inactiveVenuesSubscripiton =[...getVendorDirectBookingLinkVenuesSubscriptionResponse.payload?.inactiveSubscriptions,...getVendorDirectBookingLinkVenuesSubscriptionResponse.payload?.noSubscriptionVenues]
  useEffect(()=>{
    getVendorDBLVenuesSubscription()

    // if(!profileState.vendorProfile.payload && authState.isAuthenticated){
    //   // fetchProfile()
    // }
  },[])


  const getVendorDBLVenuesSubscription=()=>{
    dispatch(getVendorDirectBookingLinkVenuesSubscription({callback:(res)=>{
      console.log("getVendorDirectBookingLinkVenuesSubscription:",res)
        if(res?.payload){
          setInactiveVenuesSubscripiton([...res?.payload?.inactiveSubscriptions,...res?.payload?.noSubscriptionVenues])
        }
    }
    }))
  }

  const fetchProfile = async (token?: string) => {
    dispatch(getVendorProfile({
        callback: (profile) => {
          
        }
    }))
}

  const handleCopy = async (url:string,venue:any) => {
    setSelectedVenueIdForCopy(venue?._id)
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => {
      setCopied(false)
      setSelectedVenueIdForCopy(null)
    }, 1000);
  };

  const subscriptionHandler=(venue:any)=>{
    setSelectedVenueId(venue?._id)
    setSelectedVenueDetailsForSubscription(venue)
    //api call
    getSubscriptionPlanDetailsHandler((res)=>{
      if(res){
        setShowSubscriptionModal(true)
      
      }
    })
  }

  const getSubscriptionPlanDetailsHandler=(cb=null)=>{
    dispatch(getSubscriptionPlanDetails({callback:(res)=>{
      try {
          if(res?.payload){
            console.log("getSubscriptionPlanDetails:",res)

            if(typeof cb === "function"){
              cb(res?.payload)
            }
          }
      } catch (error) {
        console.log("getSubscriptionPlanDetails error:",error)
      }
    }}))
  }

  const getActiveSubscriptionBtntxt=(subscription:any)=>{
    if(!subscription?.planId){
      return "Subscribe Now"
    }

    // let now= moment()
    // const daysLeft = moment(subscription?.directBookingLink?.expiryDate).diff(now, "days");

    if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_Monthly){
      return "Upgrade Now"
    }else if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_LIFETIME){
      return "Renew Now"
    }else{
      return "Renew Now"
    }
  }

  const getIsActiveSubscriptionBtnDisable=(subscription:any)=>{
    let now= moment()
    const daysLeft = moment(subscription?.directBookingLink?.expiryDate).diff(now, "days");
    if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_Yearly && daysLeft > Values.RENEWAL_WINDOW_DAYS_YEARLY){
      return true
    }else  if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_Monthly && daysLeft > Values.RENEWAL_WINDOW_DAYS_MONTHLY){
      return false
    }else  if(subscription?.planId === Values.vendorSubscriptionsPlanId.DBL_LIFETIME && daysLeft > Values.RENEWAL_WINDOW_DAYS_MONTHLY){
      return true

    } else{
      return false
    }
  }
  const rederUi=()=>{
    if(getVendorDirectBookingLinkVenuesSubscriptionResponse.isLoading){
      return <SubscriptionPageSkeleton/>
    }
    return (<div className="max-w-6xl mx-auto p-6 space-y-8">
    {/* Active Subscriptions */}
    {getVendorDirectBookingLinkVenuesSubscriptionResponse.payload?.activeSubscriptions?.length > 0 && (
      <section>
        <div className="flex items-center gap-2 mb-4">
          <Crown className="w-5 h-5 text-green-500" />
          <h2 className="font-display text-[19px] font-bold text-flup-ink">
            Active Subscriptions ({getVendorDirectBookingLinkVenuesSubscriptionResponse.payload?.activeSubscriptions?.length})
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {getVendorDirectBookingLinkVenuesSubscriptionResponse.payload?.activeSubscriptions?.map((venue:any) => (
            <Card
              key={venue._id}
              className="border-2 border-green-200 bg-flup-surface shadow-lg hover:shadow-xl transition-shadow"
            >
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  <div className="flex gap-4">
                    <img
                      src={venue.venueThumbnail}
                      alt={venue.name}
                      className="w-16 h-16 rounded-lg object-cover border-2 border-flup-hairline"
                    />
                    <div>
                      <CardTitle className="text-lg">{venue.name}</CardTitle>
                        <p className="text-sm text-muted-foreground">
                          {venue?.address?.address} {venue?.address?.locality} {venue?.address?.state}
                        </p>
                    </div>
                  </div>
                  <Badge className="bg-green-500 hover:bg-green-600">
                    <Check className="w-3 h-3 mr-1" />
                    Active
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="bg-green-50 rounded-lg p-3 space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-flup-ink-2">Plan:</span>
                    <Badge
                      variant="outline"
                      className="border-blue-500 text-flup-info"
                    >
                      {venue.subscriptionDetails?.planId}
                    </Badge>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-flup-ink-2 flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      Expires:
                    </span>
                    <span className="font-medium">
                      {moment(venue.subscriptionDetails.directBookingLink?.expiryDate).format("DD-MM-YYYY")}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <Link2 className="w-4 h-4 text-flup-violet" />
                    <a
                      href={venue.subscriptionDetails.directBookingLink?.completeUrl}
                      className="text-flup-violet hover:underline truncate"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {venue.subscriptionDetails.directBookingLink?.completeUrl}
                    </a>
                    <button
                      onClick={()=>handleCopy(venue.subscriptionDetails.directBookingLink?.completeUrl,venue)}
                      className="ml-auto text-flup-ink-3 hover:text-flup-violet transition-colors"
                      aria-label="Copy booking link"
                    >
                      {copied && selectedVenueIdForCopy === venue?._id ? (
                        <Check className="w-4 h-4 text-green-500" />
                      ) : (
                        <Copy className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>
                <div className="flex gap-2">
                  <ButtonWithLoader
                    variant="outline"
                    className="flex-1 border-blue-500 text-flup-info hover:text-blue-800 hover:bg-flup-info-soft courser-pointer" 
                    onClick={()=>{
                      navigate(`${routes.venueManagement}/${venue?._id}`)
                    }}
                  >
                    Manage
                  </ButtonWithLoader>
                  <ButtonWithLoader 
                    isLoading={getSubscriptionPlanDetailsResponse.isLoading && venue?._id === selectedVenueId }
                    disabled={getIsActiveSubscriptionBtnDisable(venue.subscriptionDetails)}
                    onClick={()=>subscriptionHandler(venue)}
                    className="flex-1 bg-flup-brand hover:bg-flup-brand-press text-white">
                    {/* Renew */}
                    {getActiveSubscriptionBtntxt(venue.subscriptionDetails)}
                  </ButtonWithLoader>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    )}

    {/* Inactive / Not Subscribed */}
    {inactiveVenuesSubscripiton?.length > 0 && (
      <section>
        <div className="flex items-center gap-2 mb-4">
          <Link2 className="w-5 h-5 text-flup-ink-3" />
          <h2 className="font-display text-[19px] font-bold text-flup-ink">
            Subscribe Your Venues ({inactiveVenuesSubscripiton.length})
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {inactiveVenuesSubscripiton?.map((venue) => (
            <Card
              key={venue?._id}
              className="border-2 border-dashed border-flup-hairline-2 bg-white/50 hover:border-purple-300 hover:bg-flup-surface transition-all"
            >
              <CardHeader className="pb-2">
                <div className="flex items-start justify-between">
                  <div className="flex gap-4">
                    <img
                      src={venue?.venueThumbnail}
                      alt={venue?.name}
                      className="w-16 h-16 rounded-lg object-cover grayscale"
                    />
                    <div>
                      <CardTitle className="text-lg text-flup-ink-2">
                        {venue.name}
                      </CardTitle>
                      <p className="text-sm text-muted-foreground">
                      {venue?.address?.address} {venue?.address?.locality} {venue?.address?.state}
                      </p>
                    </div>
                  </div>

                  {venue.subscriptionDetails?
                   <Badge variant="secondary" className="bg-red-200">
                    Expired
                  </Badge>:
                    <Badge variant="secondary" className="bg-flup-sunken">
                    Not Subscribed
                  </Badge>
                }
                 
                </div>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="bg-flup-surface-alt rounded-lg p-3">
                  <p className="text-sm text-flup-ink-2">
                    Get a DirectBookingLink for this venue to enable:
                  </p>
                  <ul className="mt-2 space-y-1 text-sm text-flup-ink-2">
                    <li className="flex items-center gap-2">
                      <Check className="w-4 h-4 text-green-500" />
                      Direct booking URL
                    </li>
                    <li className="flex items-center gap-2">
                      <Check className="w-4 h-4 text-green-500" />
                      Increased visibility
                    </li>
                    <li className="flex items-center gap-2">
                      <Check className="w-4 h-4 text-green-500" />
                      Priority support
                    </li>
                  </ul>
                </div>
                <ButtonWithLoader 
                isLoading={getSubscriptionPlanDetailsResponse.isLoading && venue?._id === selectedVenueId}
                onClick={()=>subscriptionHandler(venue)}
                className="w-full bg-flup-brand hover:bg-flup-brand-press text-white">
                 {getActiveSubscriptionBtntxt(venue?.subscriptionDetails || null)}
                </ButtonWithLoader>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    )}
  </div>)
  }

  const closeHandler=()=>{
    setShowSubscriptionModal(false)
    setSelectedVenueId(null)
    setSelectedVenueDetailsForSubscription(null)
    getVendorDBLVenuesSubscription()
  }

  const rederSubscriptionModal=()=>{
    return <CommonPopup
    isOpen={showSubscriptionModal && selectedVenueId && selectedVenueDetailsForSubscription}
    title={"Direct Booking Link"}
    headerIcon={<LinkIcon className="w-4 h-4"/>}
    description={
     <DirectBookingPremium
      closeHandler={closeHandler}
      getVendorDBLVenuesSubscription={getVendorDBLVenuesSubscription}
      selectedVenueId={selectedVenueId}
      vendorId={selectedVenueDetailsForSubscription?.vendorId}
      venue={selectedVenueDetailsForSubscription}
    />}
    footer={<></>}
    onClose={()=>{
      closeHandler()
    }}
    mainclassName={
    ` w-[calc(100vw-200px)]
      md:max-w-[calc(100vw-200px)]
      lg:max-w-[calc(100vw-400px)]
      xl:max-w-[calc(100vw-650px)]
      min-w-[320px]`}
      showfooter={false}
    />
  }


  const renderPaymentProcessing=()=>{
    return showPaymentProcessing && <PaymentProcessing />
  }

  const renderPaymentSucessCard=()=>{
    return showPaymentSuccess && <SuccessBookingAnimation
        onClose={()=>{
          getVendorDBLVenuesSubscription()
          dispatch(setShowPaymentSuccess(false))
        }}
        show={true}
    />
  }
  
  
  return (
    <>

    {renderPaymentProcessing()}  
    {rederSubscriptionModal()}
    {renderPaymentSucessCard()}
    <div className="space-y-4">
      {/* Header */}
      <div className="bg-flup-brand text-white p-6 rounded-flup-lg">
        <div className="max-w-6xl flex flex-col items-start justify-start">
         <div>
         <ButtonWithLoader
            className="text-white bg-white/20 mb-0 mr-2"
            onClick={() => navigate(-1)}
            variant="default"
            size="icon"
          >
            <ArrowLeft className="w-4 h-4 " />
            
          </ButtonWithLoader>
          Back
         </div>
          
          <h1 className="text-2xl font-bold">Venue Subscriptions</h1>
          <p className="text-white/80 mt-1">
            Manage DirectBookingLink subscriptions for your venues
          </p>
        </div>
      </div>

      {rederUi()}
  
    </div>
    </>
  );
};

export default Subscription;
